import { useEffect } from 'react';

const LiveChat = () => {
  useEffect(() => {
    // Tawk.to Live Chat Widget
    // Replace 'YOUR_TAWK_TO_PROPERTY_ID' with actual Tawk.to Property ID
    // To get this: Sign up at https://tawk.to/ → Get your property ID from the widget code
    
    const Tawk_API = window.Tawk_API || {};
    const Tawk_LoadStart = new Date();
    
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/YOUR_TAWK_TO_PROPERTY_ID/default';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    
    // Only load if property ID is configured
    if (!script.src.includes('YOUR_TAWK_TO_PROPERTY_ID')) {
      const s0 = document.getElementsByTagName('script')[0];
      s0.parentNode.insertBefore(script, s0);
    } else {
      console.log('Tawk.to: Please configure your Property ID in LiveChat.jsx');
    }

    return () => {
      // Cleanup: Remove Tawk widget when component unmounts
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    };
  }, []);

  return null; // This component doesn't render anything visible
};

export default LiveChat;

/*
 * SETUP INSTRUCTIONS:
 * 
 * 1. Sign up for free at https://tawk.to/
 * 2. Create a new property for your website
 * 3. Go to Administration → Channels → Chat Widget
 * 4. Copy your Property ID from the widget code (looks like: 5f9a1234567890abc/1abc2def)
 * 5. Replace 'YOUR_TAWK_TO_PROPERTY_ID' in the script.src above with your actual ID
 * 6. The chat widget will appear automatically on your site
 * 
 * CUSTOMIZATION:
 * - You can customize widget appearance, position, and behavior from Tawk.to dashboard
 * - Set business hours, automated messages, and more
 * - Mobile apps available for iOS and Android to respond to chats
 */
